import compose from '../../../../src/web/utils/react/compose';
import {
  widget,
  editor,
} from '../../../../src/web/components/widgets/decorators';
import Video from '../../../components/stateless/Video';
import { NAME, ID } from './properties';
import VideoEditor from './Editor';
// import style from '../styles';

export default compose(
  editor(VideoEditor),
  widget({ name: NAME, category: 'Video', componentId: ID }, {}),
)(Video);
